import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Logger } from '@phoenix/ui/common';
import { DataTableOptions } from '@phoenix/ui/datatable';
import { ModalOptions, ModalRef, ModalService } from '@phoenix/ui/modal';
import { Subscription } from 'rxjs';
import { GlobalCountries } from './global-countries';

@Component({
  selector: 'dts-mfa-warning-modal',
  templateUrl: './mfa-warning-modal.component.html',
  styleUrls: ['./mfa-warning-modal.component.scss']
})
export class MfaWarningModalComponent implements OnInit {

  @ViewChild('header', {read: TemplateRef}) header: TemplateRef<any>;
  @ViewChild('troubleSiginIn', { read: TemplateRef }) troubleSiginIn: TemplateRef<any>;
  @ViewChild('troubleSiginInFooter', { read: TemplateRef }) troubleSiginInFooter: TemplateRef<any>;
  private TSigninInModalRef: ModalRef;

  public pageSizeScroll = 40;
  readonly totalScroll = 57;
  optionsScroll: DataTableOptions;
  loading = false;
  gridSubscription: Subscription;
  countryData: Array<any> = [];

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  openTroubleSignInModal() {
    const modalOptions: ModalOptions = {
      title: this.header,
      content: this.troubleSiginIn,
      footer: this.troubleSiginInFooter,
      dismissable: true,
      position: {
        top: '120px'
      },
      size: 'lg',
      hasBackdrop: true,
      draggable: false,
      closeBtnAriaLabel: 'close'
    };
    this.TSigninInModalRef = this.modalService.open(modalOptions);
  }

  /**
   * Close Contact us modal
   */
  public closeTSiginInHandler() {
    this.modalService.close(this.TSigninInModalRef.modal);
  }
}